"use client";

import styles from "./header-product.module.css";
import Image from "next/image";
import BuyingOption from "@/product/[id]/Components/BuyingOptions/BuyingOptions";
import {FaInfoCircle} from "react-icons/fa";
import Link from "next/link";
import {FaChevronLeft} from "react-icons/fa6";
import { FaShoppingCart } from "react-icons/fa";
import {useSelector} from "react-redux";
import {
    getWebsiteProductImageFitMode,
    getWebsiteProductImageUrl,
} from "@/lib/product-presentation";

export default function HeaderProduct({ product }) {
    const items = useSelector(state => state.cart.items);
    const count = Object.values(items).reduce(
        (sum, item) => sum + Math.max(1, Number(item?.quantity || 1)),
        0
    );
    const heroImage = getWebsiteProductImageUrl(product);
    const imageFitMode = getWebsiteProductImageFitMode(product);
    const flipClassName = [
        styles.flip,
        imageFitMode === "wide" ? styles.flipWide : "",
        imageFitMode === "square" ? styles.flipSquare : "",
        imageFitMode === "tall" ? styles.flipTall : "",
    ].filter(Boolean).join(" ");

    return (
        <div className={styles.header}>
            <div className={`ux-container ${styles.headerContent}`}>
                <div className={styles.heroPanel}>
                    <div className={styles.heroMedia}>
                        <div className={styles.FLIPSpotlightShadowProductBottom}>
                            <div className={styles.spotlightShadowProductBottom} />
                        </div>
                        <div className={flipClassName}>
                            <Image
                                src={heroImage}
                                alt={product.name}
                                fill
                                sizes="(max-width: 576px) 300px, (max-width: 768px) 360px, (max-width: 1200px) 48vw, 560px"
                                priority
                                className={styles.heroImage}
                            />
                        </div>
                    </div>

                    <div className={styles.buyAProduct}>
                        <div className={styles.purchaseCard}>
                            <div className={styles.purchaseEyebrow}>Purchase options</div>
                            <h4 className="m-0">Buy <b>{product.name}</b></h4>
                            <div className={styles.purchaseMeta}>
                                {count > 0 ? `${count} item${count === 1 ? "" : "s"} in cart` : "Cart is empty"}
                            </div>
                            <div className="small alert alert-primary p-2 my-2 d-flex align-items-start gap-2 rounded-2">
                                <FaInfoCircle size={18} className="mt-1 flex-shrink-0" />
                                <div className="text-start fst-italic" style={{ lineHeight: "1.2" }}>
                                    Select the option you want, adjust quantity if needed, and continue straight to cart.
                                </div>
                            </div>

                            {product?.buying_options && product.buying_options.map((option, i) =>
                                <BuyingOption
                                    key={`${product.alt_id}-${i}`}
                                    product={product}
                                    alt_id={product.alt_id}
                                    option={option}
                                />
                            )}
                            <div className={styles.buyingOptionsNavButtons}>
                                <Link href="/solution/custom" className="btn btn-success btn-sm">
                                    <FaChevronLeft size={14} className="me-1" />
                                    All Products
                                </Link>
                                <Link href="/cart" className="btn btn-primary btn-sm">
                                    Go to Cart <FaShoppingCart size={14} /> ({count})
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.headerBackgroundWrapper}>
                <div className={styles.headerBackground}>
                    <div className={styles.headerTopPart} />
                    <div className={styles.headerBottomPart} />
                    <div className={styles.headerBackgroundBlur} />
                </div>
            </div>
        </div>
    );
}
